import React, { useContext, useEffect, useState } from "react";
import {
    Box,
    Container,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Dossier, fetchDossier } from "../../../services/stixify_api.ts";
import { TeamContext } from "../../../contexts/team-context.tsx";
import DossierForm from "./dossier-form.tsx";


function EditDossierPage() {
    const navigate = useNavigate()
    const {id} = useParams<{id: string}>()
    const [dossier, setDossier] = useState<Dossier | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const { activeTeam } = useContext(TeamContext);

    const loadDossier = async () => {
        if (!id || !activeTeam) return
        const res = await fetchDossier(activeTeam?.id, id);
        setDossier(res.data)
    }

    useEffect(() => { loadDossier(); }, [activeTeam, id]);
    useEffect(() => {
        document.title = 'Edit Dossier | Stixify Web'
    }, [])


    return (
        <Box p={4}>
            <DossierForm
                open={true}
                onClose={() => navigate(-1)}
                onAddEntry={() => navigate(-1)}
                entryData={dossier}
            >
            </DossierForm>
        </Box>
    );
}

export default EditDossierPage;
